module.exports = __webpack_public_path__ + "img/1.28abb9d1.jpg";